(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["watt-global-menu-widget"] && !Shopify.designMode) return;
  try {
    /**
 * 全局第三方代码区域
 * */
document.addEventListener('DOMContentLoaded', function() {
  // impact 跨站点追踪的需求
  try {
    const imRef = new URLSearchParams(window.location.search).get('im_ref');
    if (!imRef) return;

    function processGlobalMenu() {
      const widget = document.querySelector('watt-global-menu-widget');
      if (!widget || !widget.shadowRoot) return false;

      const links = widget.shadowRoot.querySelectorAll('.watt-global-menu-dropdown__link');
      links.forEach(link => {
        const url = new URL(link.href);
        if (!url.searchParams.has('im_ref')) {
          url.searchParams.set('im_ref', imRef);
          link.href = url.toString();
        }
      });
      return true;
    }

    if (!processGlobalMenu()) {
      const observer = new MutationObserver(() => {
        if (processGlobalMenu()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 3000);
    }
  } catch (err) {
    // 捕获异常，防止整个脚本崩溃
    console.error('Global Menu Script Error:', err);
  }
});
  } catch(e) { console.error(e); }
})();

})();
